import React from 'react';
import { Languages, Database, Lock, Zap, Globe2, Shield, Quote } from 'lucide-react';

export default function AboutPage() {
  return (
    <div>
      <div className="relative border-b border-white/5">
        <div className="absolute inset-0 stars-bg twinkle" />
        <div className="absolute inset-0 bg-grid opacity-30" />
        <div className="relative mx-auto max-w-[1400px] px-6 py-8">
          <div className="mono text-[10px] tracking-[0.2em] text-cyan-300/90 uppercase mb-2">À propos du projet</div>
          <h1 className="serif text-3xl md:text-4xl max-w-4xl leading-tight">Atlas <span className="italic text-cyan-300">indépendant</span> et francophone des dossiers UAP déclassifiés.</h1>
          <p className="text-2 mt-2 max-w-3xl text-sm">PURSUE FR est une réplique enrichie de la PURSUE Release 01 du Ministère de la Guerre américain (war.gov/UFO), traduite et contextualisée pour le public francophone.</p>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-6 py-8 grid lg:grid-cols-3 gap-3">
        {[
          { i: Languages, c:'cyan-300', t:'Traduction intégrale', d:"Titres, résumés et métadonnées traduits en français. Les vidéos YouTube intègrent les sous-titres FR auto-générés lorsqu'ils sont disponibles." },
          { i: Database, c:'amber-300', t:'161 dossiers indexés', d:"Recherche par mot-clé sur l'ensemble de la Release 01 : Ministère de la Guerre (82), FBI (57), NASA (15), Département d'État (7)." },
          { i: Globe2, c:'emerald-300', t:'Atlas géospatial', d:"Carte 3D interactive géolocalisant 27 incidents à travers le monde. 47 dossiers sans coordonnées géographiques publiques, 10 hors-Terre." },
          { i: Lock, c:'violet-300', t:'Recherche locale · sans télémétrie', d:"Toutes les recherches s'effectuent dans votre navigateur. Aucune requête vers un serveur tiers, aucune trace utilisateur." },
          { i: Zap, c:'rose-300', t:'Mises à jour rolling', d:"Le Ministère de la Guerre publie de nouveaux documents toutes les quelques semaines. PURSUE FR intègre les nouvelles vagues dès leur disponibilité." },
          { i: Shield, c:'cyan-300', t:'Sources publiques uniquement', d:"Aucune affiliation gouvernementale. Données issues de war.gov, aaro.mil, archives.gov et d'auditions officielles du Congrès américain." },
        ].map((f, i) => (
          <div key={i} className="glass rounded-lg p-4 doc-card">
            <div className={`h-8 w-8 rounded-md bg-${f.c}/10 border border-${f.c}/30 flex items-center justify-center mb-2.5`}>
              <f.i className={`h-4 w-4 text-${f.c}`} />
            </div>
            <div className="text-1 font-medium text-base mb-1">{f.t}</div>
            <p className="text-2 text-xs leading-relaxed">{f.d}</p>
          </div>
        ))}
      </div>

      <div className="mx-auto max-w-[1400px] px-6 pb-8">
        <div className="glass-strong rounded-xl p-6 md:p-8 relative overflow-hidden">
          <Quote className="absolute -right-4 -top-4 h-32 w-32 text-amber-300/10" />
          <div className="mono text-[10px] tracking-[0.2em] text-amber-300/90 uppercase mb-3">Directive Présidentielle — 19 février 2026</div>
          <p className="serif text-lg md:text-xl leading-snug max-w-4xl text-1">
            « Compte tenu de l'énorme intérêt manifesté, je vais ordonner au Secrétaire à la Guerre et aux autres départements de commencer le processus d'identification et de publication des fichiers gouvernementaux relatifs aux phénomènes aériens non identifiés. »
          </p>
          <div className="mt-4 mono text-[10px] text-3">— DONALD J. TRUMP, TRUTH SOCIAL</div>
        </div>
      </div>

      <div className="mx-auto max-w-[1400px] px-6 pb-14">
        <div className="glass rounded-lg p-5">
          <div className="mono text-[10px] tracking-[0.2em] text-cyan-300/90 uppercase mb-2">Mentions légales</div>
          <p className="text-2 leading-relaxed text-sm">
            PURSUE FR est une initiative <span className="text-1">strictement indépendante</span>, à but non lucratif et éducatif. Le site n'est ni affilié, ni endossé, ni opéré par le gouvernement des États-Unis, le Ministère de la Guerre, le FBI, la NASA, le Département d'État ou l'AARO. Toutes les données présentées sont issues de <span className="text-cyan-300">sources publiques officielles</span>.
          </p>
        </div>
      </div>
    </div>
  );
}
